/**
 * @module web/store
 * @private
 */

let layoutToken = {};

/**
 * Update the layout token with the given x-query and x-token. This object will be saved in memory.
 * @param {String} section - Contains layout section to update the proper one.
 * @param {String} xQuery - Contains the layout x-query to update.
 * @param {String} xToken - Contains the layout x-token to update.
 * @public
 */
const update = function(section, tokenObject = {}) {
  return (layoutToken[section] = { xQuery: tokenObject.xQuery, xToken: tokenObject.xToken });
};

/**
 * Returns the current stored playback token, if any, which will be searched in memory.
 *
 * @returns {string} - A found stored playback token or null if memory does not have a valid one.
 * @public
 */
const get = function(section) {
  return layoutToken[section] || {};
};

/**
 * Clears layout token data object.
 *
 * @param {String} section - Contains layout section to update the proper one.
 * @public
 */
const clear = function() {
  layoutToken = {};
};

export default { update, get, clear };
